<template>
  <TextField
    id="mealplan-certificate-password"
    name="keystore.certificate.password"
    :label="translate(`${LOCALE_PREFIX}.form.password`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.passwordPlaceholder`)"
    :disabled="!editMealPlan"
    :required="editMealPlan"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../../enums';
import { useFinancialConfigStore } from '../../../../../../routes';

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);
</script>
